<template>
    <a
        :href="href"
        tabindex="0"
        class="skip-btn btn"
        data-test="skip-button">
        {{ textForLink }}
    </a>
</template>

<script>
    export default {
        props: {
            hash: { type: String, default: "" },
            linkText: { type: String, default: null },
        },
        computed: {
            href: function () {
                return `#${this.hash}`;
            },
            textForLink() {
                return this.linkText !== null
                    ? this.linkText
                    : this.$formatMessage({ defaultMessage: "Skip to main content", id: "buttons.skip.mainContent" });
            },
        },
    };
</script>

<style lang="scss">
    @use "./SkipButton.scss";
</style>
